export interface Tax {
  id: number;
  title: string;
  multiplier: number;
  createdAt: Date;
  updatedAt: Date;
}

export const getEmptyTax = (): Tax => ({
  id: 0,
  title: '',
  multiplier: 0,
  createdAt: new Date(),
  updatedAt: new Date(),
});

export const taxFromResponse = (responseData: any): Tax => ({
  id: responseData.id,
  title: responseData.title,
  multiplier: responseData.multiplier * 100,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});

export const taxToUpsertRequest = (tax: Tax) => ({
  title: tax.title,
  multiplier: tax.multiplier / 100,
});
